'use client';

import { useCallback } from 'react';
import { KEYBOARD_KEYS } from '@federa/const/keyboard-events';

export function useEnterKeyHandler(onSubmit: () => void | Promise<void>): (e: React.KeyboardEvent) => void {
	return useCallback(
		(e: React.KeyboardEvent) => {
			if (e.key === KEYBOARD_KEYS.ENTER && !e.shiftKey) {
				e.preventDefault();
				void onSubmit();
			}
		},
		[onSubmit],
	);
}
